




















































import Vue from 'vue'
import { mapActions, mapState } from 'vuex'
import XButton from '@/components/atoms/Button/XButton.vue'
import XInput from '@/components/atoms/Input/XInput.vue'
import XPasswordInput from '@/components/atoms/Input/XPasswordInput.vue'

export default Vue.extend({
  name: 'Login',
  components: { XButton, XInput, XPasswordInput },
  data() {
    return {
      input: {
        email: '',
        password: '',
      },
    }
  },
  computed: {
    ...mapState('auth', ['user']),
  },
  methods: {
    ...mapActions('auth', ['login']),
    async onSubmit() {
      await this.login(this.input)
      this.redirect(this.user.emailVerified ? 'Services' : 'Verify')
    },
    async redirect(to?: string) {
      this.$router.replace(
        this.$route.params.wantedRoute || { name: to || 'Services' }
      )
    },
  },
})
